import React, { useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';
import Select from 'components/formsy/Select';

import APICkecker from '../APICkecker';

export default function Tiburon({ name, data = {} }) {
  const [username, setUsername] = useState(data.username || '')
  const [password, setPassword] = useState(data.password || '')
  const [version, setVersion] = useState(data.version || '')

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Username</Label>
          <Input required
            name="username"
            value={username}
            onChange={setUsername}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Password</Label>
          <Input type="password" required
            name="password"
            value={password}
            onChange={setPassword}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>Version</Label>
          <Select required
            name="version"
            value={version}
            onChange={option => setVersion(option?.value)}
            options={[
              { value: "version1", label: 'Version 1' },
              { value: "version2", label: 'Version 2' },
            ]}
          />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker
      partner={name}
      credentials={{ username, password, version }}
    />
  </>
}
